import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useMsal } from '@azure/msal-react'
import { Typography, Icon } from 'antd'

import { Creators as authActions } from '../../appRedux/ducks/auth/auth'

import './styles.css'

const Logout = function ({ history }) {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()
  const dispatch = useDispatch()

  useEffect(() => {
    const performLogout = async () => {
      window.localStorage.clear()
      dispatch(authActions.reset())
      if (activeAccount) {
        await instance.logoutRedirect()
      }

      history.push('/')
    }

    performLogout()
  }, [instance, history])

  return (
    <div className="logout-container">
      <div className="logout-content">
        <Icon spin type="loading" style={{ fontSize: 50, color: '#E21D45' }} />
        <Typography className="logout-text">{'Deslogando usuário...'}</Typography>
      </div>
    </div>
  )
}

export default Logout
